import { useContext } from 'react'

import { UserTrackingContext } from './UserTrackingContext'

export function useUserTracking() {
	return useContext(UserTrackingContext)
}
